/* hpl-tonkarte-audio · N126
   Macht die Tonkarte anspielbar. Progressive Enhancement: Die Karte ist reines Liquid+SVG
   und ohne JavaScript vollstaendig sichtbar - dieses Script haengt nur das Hoeren dran.

   KLANG: Das sind keine Aufnahmen, sondern Synthese. Eine Handpan klingt harmonisch
   (Grundton, Oktave, Duodezime = Oktave+Quinte), hat einen sehr kurzen, perkussiven
   Anschlag und einen metallischen Nachklang. Nachgebaut mit:
     - drei Sinustoenen f / 2f / 3f, leicht verstimmt (+-3 Cent) gegen sterile Phasenlage
     - Obertoene klingen SCHNELLER ab als der Grundton (so verhaelt sich Metall)
     - gefilterter Rauschimpuls (8 ms, quadratischer Abfall) als Anschlag - der "Attack"
     - Tiefpass, der mit dem Ton zufaellt: hell im Moment des Schlags, dann weicher
   Ausklang bewusst kurz (Max: "nicht zu lang ausklingend"): Grundton ~1,6 s, und
   ab B4 zusaetzlich fallend - je Oktave darueber die halbe Dauer (Max, 09.08.).
   Alles lizenzfrei und ohne Dateigewicht. Echte Samples waeren schoener - siehe README
   im Kopf der Produktseite bzw. CHANGE-LOG N126.
*/
(function () {
  'use strict';

  var HALBTON = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11, H: 11 };

  // "F#4", "Bb3", "C5" -> Frequenz in Hz (A4 = bezug, Standard 440; Serien-Seiten rufen auch mit 432 auf)
  function frequenz(name, bezug) {
    var m = String(name || '').trim().match(/^([A-Ha-h])([#b♯♭]?)(-?\d)$/);
    if (!m) return null;
    var h = HALBTON[m[1].toUpperCase()];
    if (h == null) return null;
    if (m[2] === '#' || m[2] === '♯') h += 1;
    else if (m[2] === 'b' || m[2] === '♭') h -= 1;
    var midi = (parseInt(m[3], 10) + 1) * 12 + h;   // C4 = MIDI 60
    return (bezug || 440) * Math.pow(2, (midi - 69) / 12);
  }

  var ctx = null;
  function audio() {
    if (!ctx) {
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      /* Serien-Seiten legen den Kontext schon in der Berührung an (iPhone/iPad), bevor diese Datei geladen ist */
      ctx = window.__hplAudioCtx || new AC();
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
  }

  // Kurzer Rauschimpuls = der Anschlag. Ohne ihn klingt es wie eine Orgel, nicht wie Metall.
  function anschlag(c, ziel, t0, staerke) {
    var laenge = Math.floor(c.sampleRate * 0.008);
    var puffer = c.createBuffer(1, laenge, c.sampleRate);
    var d = puffer.getChannelData(0);
    for (var i = 0; i < laenge; i++) {
      // Quadratischer Abfall = knackiger als linear.
      var h = 1 - i / laenge;
      d[i] = (Math.random() * 2 - 1) * h * h;
    }
    var q = c.createBufferSource(); q.buffer = puffer;
    // Hoeher und breiter als zuvor (3400 statt 2600, Q 0.45 statt 0.7): mehr Metall im Schlag.
    var bp = c.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 3400; bp.Q.value = 0.45;
    var g = c.createGain(); g.gain.value = staerke;
    q.connect(bp); bp.connect(g); g.connect(ziel);
    q.start(t0); q.stop(t0 + 0.03);
  }

  function midiNr(name) {
    var m = String(name || '').trim().match(/^([A-Ha-h])([#b♯♭]?)(-?\d)$/);
    if (!m) return null;
    var h = HALBTON[m[1].toUpperCase()];
    if (h == null) return null;
    if (m[2] === '#' || m[2] === '♯') h += 1;
    else if (m[2] === 'b' || m[2] === '♭') h -= 1;
    return (parseInt(m[3], 10) + 1) * 12 + h;
  }

  // Ab B4 (MIDI 71) klingt es kuerzer aus - je Oktave darueber halbiert sich die Dauer.
  // Kleine, hohe Tonfelder schwingen real kuerzer nach. Der Zusatzfaktor 0.93 zieht den
  // ganzen oberen Bereich nochmal leicht zusammen (Max zu C5, 09.08.: "ganz wenig
  // kuerzer") - ohne ihn waere C5 als erster Ton ueber der Grenze fast unveraendert.
  // Untergrenze 0.40, damit der hoechste Ton nicht zum blossen Klick wird.
  function dauerFaktor(name) {
    var midi = midiNr(name);
    if (midi == null || midi <= 71) return 1;
    return Math.max(0.40, 0.93 * Math.pow(0.5, (midi - 71) / 12));
  }

  // Anschlag waechst mit der Tonhoehe: hohe Felder klingen perkussiver als tiefe.
  function anschlagPegel(name) {
    var midi = midiNr(name);
    if (midi == null) return 0.34;
    return Math.min(0.46, 0.34 + Math.max(0, midi - 71) * 0.010);
  }

  function spiele(name, bezug) {
    var f = frequenz(name, bezug);
    var c = audio();
    if (!f || !c) return false;
    var kuerzer = dauerFaktor(name);
    var schlag = anschlagPegel(name);

    var t0 = c.currentTime + 0.001;
    var summe = c.createGain();
    summe.gain.value = 0.9;

    // Tiefpass faellt mit dem Ton ab: im Anschlag hell, danach weich.
    var lp = c.createBiquadFilter();
    lp.type = 'lowpass';
    lp.frequency.setValueAtTime(5200, t0);
    lp.frequency.exponentialRampToValueAtTime(1400, t0 + 0.9);

    // Kompressor haelt Mehrfachanschlaege zusammen, statt zu uebersteuern.
    var komp = c.createDynamicsCompressor();
    komp.threshold.value = -14; komp.ratio.value = 5; komp.attack.value = 0.003; komp.release.value = 0.2;

    summe.connect(lp); lp.connect(komp); komp.connect(c.destination);

    // Grundton laenger, Obertoene kuerzer - so verhaelt sich schwingendes Metall.
    var teiltoene = [
      { faktor: 1, pegel: 0.55, dauer: 1.6, cent: 0 },
      { faktor: 2, pegel: 0.26, dauer: 1.0, cent: 3 },
      { faktor: 3, pegel: 0.12, dauer: 0.7, cent: -3 }
    ];
    teiltoene.forEach(function (t) {
      var o = c.createOscillator();
      o.type = 'sine';
      o.frequency.value = f * t.faktor * Math.pow(2, t.cent / 1200);
      var g = c.createGain();
      g.gain.setValueAtTime(0.0001, t0);
      g.gain.exponentialRampToValueAtTime(t.pegel, t0 + 0.003);       // 3 ms Anstieg - haerter
      var dauer = t.dauer * kuerzer;
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + dauer);        // exponentiell aus
      o.connect(g); g.connect(summe);
      o.start(t0); o.stop(t0 + dauer + 0.05);
    });

    anschlag(c, summe, t0, schlag);
    return true;
  }

  function aktiviere(karte) {
    if (karte.dataset.tkAudio === 'an') return;
    karte.dataset.tkAudio = 'an';

    karte.querySelectorAll('.tk-fld').forEach(function (g) {
      var text = g.querySelector('text');
      if (!text) return;
      var ton = text.textContent.trim();
      if (!frequenz(ton)) return;

      g.style.cursor = 'pointer';
      g.setAttribute('tabindex', '0');
      g.setAttribute('role', 'button');
      g.setAttribute('aria-label', ton + ' anhören');

      function an(ev) {
        if (ev.type === 'keydown' && ev.key !== 'Enter' && ev.key !== ' ') return;
        if (ev.type === 'keydown') ev.preventDefault();
        spiele(ton);
        var kreis = g.querySelector('circle');
        if (kreis && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          kreis.style.transition = 'none';
          kreis.style.transform = 'scale(1.06)';
          kreis.style.transformOrigin = 'center';
          kreis.style.transformBox = 'fill-box';
          setTimeout(function () {
            kreis.style.transition = 'transform .22s ease-out';
            kreis.style.transform = '';
          }, 20);
        }
      }
      g.addEventListener('pointerdown', an);
      g.addEventListener('keydown', an);
    });
  }

  function start() {
    document.querySelectorAll('.hpl-tk[data-spielbar]').forEach(aktiviere);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  window.hplTonkarteSpiele = spiele;
})();
